<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Region Type', apiMethod: 'RegionTypes', form: () => import('../forms/RegionTypeForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Region', apiMethod: 'Regions', parentForeignKey: 'regionTypeId', form: () => import('../forms/RegionForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Regions', value: 'regionTypeId', isCard: true, table: () => import('../tables/RegionsTable') },
                ],
                mainForm: () => import('../forms/RegionTypeForm'),
                claimName: 'RegionTypes',
                apiMethod: 'RegionTypes',
            }
        }
    };
</script>
